import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type {
  GroupBase,
  PlaceholderProps as ReactSelectPlaceholderProps,
} from 'react-select';
import { components } from 'react-select';

import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../../core/utils/can-receive-default-text-format.js';
import * as styles from '../styles/Select.sty.js';

type PlaceholderProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactSelectPlaceholderProps<OptionValue, isMulti, Group>;

export function Placeholder<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
>(props: Readonly<PlaceholderProps<OptionValue, isMulti, Group>>) {
  const { selectProps } = props;
  const intl = useIntl();

  // do not truncate the text for non-text children
  if (
    selectProps.placeholderText &&
    !_canReceiveDefaultTextFormat(selectProps.placeholderText)
  ) {
    return (
      <components.Placeholder {...props} className={styles.placeholderColor}>
        {selectProps.placeholderText}
      </components.Placeholder>
    );
  }

  return (
    <components.Placeholder
      {...props}
      className={clsx(
        styles.placeholderColor,
        styles.selectValueContainerTruncationBox,
      )}
    >
      {selectProps.placeholderText ??
        (selectProps.isMulti
          ? intl.formatMessage({
              defaultMessage: 'Select options',
              id: '3ZX0IG+5tekB89nr',
              description: 'Default placeholder text for the multi select.',
            })
          : intl.formatMessage({
              defaultMessage: 'Select an option',
              id: 'ggfg/kIzwBCNyGCm',
              description: 'Default placeholder text for the single select.',
            }))}
    </components.Placeholder>
  );
}
